import { Vue, Component, Ref, Emit } from 'vue-property-decorator'
import BillingAddToGridComponent from '@/modules/billing-module/shared/components/add-to-grid/billing-add-to-grid.vue'
import { BModal } from 'bootstrap-vue'
import {
    BillingModalDeliveryNotesAddToParams,
    BillingModalDeliveryNotesAddToState,
    initialBillingModalDeliveryNotesAddToState
} from '@/modules/billing-module/components/modal/delivery-notes/add-to/billing-modal-delivery-notes-add-to.model'
import { billingCommonDeliveryNoteService } from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.service'
import { store } from '@/store/store'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { BillingModalDeliveryNotesAddToGridDatasource } from '@/modules/billing-module/components/modal/delivery-notes/add-to/config/billing-modal-delivery-notes-add-to-grid.datasource'
import { BillableDeliveryNoteResponse } from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.dto'
import { BillingOperationWithConceptsGuard } from '@/modules/billing-module/shared/guards/billing-operation-with-concepts-guard'

@Component({
    components: {
        BillingAddToGridComponent
    }
})
export default class BillingModalDeliveryNotesAddTo extends Vue {
    @Ref() readonly deliveryNotesAddTo!: BModal

    @Emit()
    added(deliveryNoteId: number): number {
        return deliveryNoteId
    }

    state: BillingModalDeliveryNotesAddToState
    constructor() {
        super()
        this.state = initialBillingModalDeliveryNotesAddToState()
    }

    async show(params: BillingModalDeliveryNotesAddToParams): Promise<void> {
        const { appliedBillableConcepts } = params
        this.state = {
            ...initialBillingModalDeliveryNotesAddToState(),
            datasource: new BillingModalDeliveryNotesAddToGridDatasource(appliedBillableConcepts)
        }
        this.deliveryNotesAddTo.show()
    }
    hide(): void {
        this.deliveryNotesAddTo.hide()
    }

    async onDeliveryNoteSelected(billableDeliveryNote: BillableDeliveryNoteResponse): Promise<void> {
        if (this.state.datasource) {
            const { appliedBillableConcepts } = this.state.datasource
            await BillingOperationWithConceptsGuard.run(
                appliedBillableConcepts.length,
                async () => {
                    const response =
                        await PromiseUtils.toCallSecure(
                            billingCommonDeliveryNoteService.addConcepts(
                                store.state.labId,
                                billableDeliveryNote.id,
                                appliedBillableConcepts.map(abc => abc.id)))
                    if (response !== null) {
                        this.added(billableDeliveryNote.id) // emits an event
                    }
                }
            )
        }
    }
}
